import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuth } from "./auth.selector";

// Lightweight guard for the gym-owner dashboard. Unlike PrivateRoute it does not
// require feature-path access (SaaS owners don't have the menu-feature map) — it
// only checks that someone is logged in. Not authed → bounce to the login screen.
const OwnerRoute = ({ children }) => {
  const isAuth = useSelector(selectIsAuth);
  if (!isAuth) return <Navigate to="/signup" replace />;
  return children;
};

export default OwnerRoute;
